export class Incidence{
  constructor(
    public incidenceId: string,
    public initDate: any,
    public endDate: any,
    public description: string,
    public created: any,
    public createdBy: string,
    public modified: any,
    public modifiedBy: string,
    public sergasDeviceId: string,
    public notifications: IncidenceNotification[]
  ){}
}

export class IncidenceNotification{
  constructor(
    public notificationId: string,
    public notificationCode: number,
    public iPlaceName: string,
    public name: string,
    public description: string,
    public launchDate: any,
  ){}
}

